import { ClientFetch } from '../../fetch/ClientFetch';
import type { RawPsiCartOverview } from '../../../types/cart';
import { HTTP_METHODS } from 'utils';

/**
 * Retrieves the current shopping cart overview, including updated items and totals.
 *
 * This function is intended for client-side usage and utilizes `ClientFetch.makePsiRequest` to
 * communicate with the PSI service endpoint `shoppingcart.cart.getOverview`.
 * It allows adding a specified number of positions to the cart and returns the
 * updated cart overview.
 *
 * @param {number} addPositions - The number of positions to add to the shopping cart.
 * @returns {Promise<RawPsiCartOverview>} A promise that resolves to the updated cart overview.
 */
export const getCartOverview = async (addPositions: number): Promise<RawPsiCartOverview> => {
  const payload = {
    addPositions,
  };

  return new ClientFetch().makePsiRequest<RawPsiCartOverview>('shoppingcart.cart.getOverview', payload, {
    method: HTTP_METHODS.POST,
  });
};
